export * from './interface/index';
export * from './service/index';
export * from './storge/routeInfo-storage.service';
export * from './storge/routeInfo-storage';
export * from './dw-reuse-strategy';
// export * from './dw-tab-routing.component';
// export { DwTabRoutingModule } from './dw-tab-routing.module';
export * from 'app/implementation/shared/layout/dw-tab-routing/dw-tab-routing.component';
export { FxTabRoutingModule } from 'app/implementation/shared/layout/dw-tab-routing/dw-tab-routing.module';
